import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const ProgramContainer = styled.section`
	text-align: center;

	${props => props.theme.breakpoints.up('xs')} {
		padding: 8% 8% 15% 8%;
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding: 6% 8% 6% 8%;
	}
`;

export const StyledTypography = styled(Typography)`
	${props => props.theme.breakpoints.up('md')} {
		padding: 0% 15%;
	}
`;
